import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=539b3d46&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=539b3d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b3d46",
  null
  
)

export default component.exports